import { GlobalService } from 'src/app/global.service';
import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';

@Component({
  selector: 'app-business-type-wise-summary',
  templateUrl: './business-type-wise-summary.component.html',
  styleUrls: ['./business-type-wise-summary.component.scss']
})
export class BusinessTypeWiseSummaryComponent implements OnInit {
  sessions: any;
  selected_date: any;
  selected_session_id: any;
  is_document_available: boolean = true;
  document_file: any = null;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  title: any;
  constructor(private httpService: HttpService, private global: GlobalService) {
    this.title = this.global._active_display_name;
    this.httpService.getSession().subscribe((sessions: []) => {
      console.log(sessions);
      this.sessions = sessions;
    }, (error) => {
      console.log(error);
    });
  }

  getClicked() {
    let data_dict = {
      'selected_date': this.selected_date,
      'selected_session_id': this.selected_session_id
    };
    console.log(data_dict);
    this.is_document_available = false;
    this.httpService.serveBusinessTypeWiseSummary(data_dict).subscribe((data) => {
      console.log(data);
      this.document_file = data;
      this.is_document_available = true;
    }, (error) => {
      this.is_document_available = true;
    });
  }

  downloadClicked() {
    const linkSource = 'data:application/pdf;base64,' + this.document_file['pdf'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }
  ngOnInit() {
  }


  changeEvent() {
    this.document_file = null;
  }


}
